let loginAsUserIdForSuperAdmin: string | null = null;

export const getLoginAsUserIdForSuperAdmin = () => loginAsUserIdForSuperAdmin;

export const setLoginAsUserIdForSuperAdmin = (id: string | null) => {
    loginAsUserIdForSuperAdmin = id;
};
